// extracted by mini-css-extract-plugin
module.exports = {"landingPage":"LandingPage_landingPage__3gILx","buttonDiv":"LandingPage_buttonDiv__1LeMd","button":"LandingPage_button__35kgQ"};